import { Pipe, PipeTransform } from '@angular/core';
import { EnumType } from '../../models/enums/enum';

@Pipe({
    name: 'translateStatus'
})
export class TranslateStatusPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        if (!value || typeof value !== 'string') { return value; }
        if (value === EnumType.Status.PENDING) {
            return 'Pendiente';
        } else if (value === EnumType.Status.ACTIVE) {
            return 'Activo';
        } else if (value === EnumType.Status.INACTIVE) {
            return 'Inactivo';
        } else if (value === EnumType.Status.DELETED) {
            return 'Eliminado';
        } else {
            return value;
        }
    }

}
